// extracted by mini-css-extract-plugin
export var actionButton = "_68-1";
export var actionButtons = "_68-2";
export var actions = "_68-0";
export var aiUnread = "_68-10";
export var alignCenter = "_68-h";
export var backWrapper = "_68-3";
export var cellContainer = "_68-4";
export var checkboxContainer = "_68-5";
export var contentContainer = "_68-6";
export var contentHeader = "_68-8";
export var conversationsTableWrapper = "_68-s";
export var draftReplyBadgeContainer = "_68-m";
export var dropdownItem = "_68-b";
export var dropdownItemsContainer = "_68-a";
export var dropdownTitle = "_68-c";
export var errorIcon = "_68-7";
export var filter = "_68-d";
export var gray = "_68-i";
export var headerActionButtons = "_68-e";
export var headerCheckboxContainer = "_68-f";
export var icon = "_68-j";
export var menuContainer = "_68-k";
export var noMoreTicketsIcon = "_68-12";
export var noMoreTicketsSubText = "_68-13";
export var oneLine = "_68-l";
export var optionsButton = "_68-n";
export var plus = "_68-o";
export var portalButtonsWrapper = "_68-g";
export var red = "_68-p";
export var scrolledTop = "_68-9";
export var search = "_68-q";
export var selectedConversationsCount = "_68-r";
export var spinner = "_68-t";
export var strong = "_68-u";
export var summaryCell = "_68-v";
export var tableContainer = "_68-11";
export var tagContainer = "_68-w";
export var threeDots = "_68-x";
export var twoLines = "_68-y";
export var unread = "_68-z";